import { LoadingStatus } from '@/enums/LoadingStatus.enum';

export type DefectCodesLoadError = 'session-expired' | 'request-failed';

const UNAUTHORIZED_STATUSES: readonly number[] = [401, 403];

/**
 * Classifies a failed defect-code download from the HTTP statuses of its requests.
 */
export function resolveDefectCodesLoadError(statuses: readonly number[]): DefectCodesLoadError {
  return statuses.some((status) => UNAUTHORIZED_STATUSES.includes(status))
    ? 'session-expired'
    : 'request-failed';
}

/**
 * Picks the translation key that tells the inspector why defect codes are missing
 * and what to do next.
 */
export function resolveDefectCodesUnavailableMessageKey(input: {
  status: LoadingStatus | undefined;
  loadError: DefectCodesLoadError | null;
  isOnline: boolean;
}): string {
  if (input.loadError === 'session-expired') {
    return 'Defect_Codes_Session_Expired';
  }
  if (!input.isOnline) {
    return 'Defect_Codes_Offline';
  }
  if (input.status === LoadingStatus.LOADING) {
    return 'Defect_Codes_Loading';
  }
  if (input.status === LoadingStatus.FAILED || input.loadError === 'request-failed') {
    return 'Defect_Codes_Download_Failed';
  }
  return 'Defect_Codes_Not_Available';
}
